enum SupervisionStatus {
   Accepted = 'Accepted',
   Declined = 'Declined',
   Pending = 'Pending',
   Cancelled = 'Cancelled',
}

export default SupervisionStatus;
